// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 991px) {
  .container1 {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .container1-intro {
    width: 100%;
    justify-content: center;
    align-items: flex-start;
  }

  .container1-intro article {
    margin-top: 7rem;
    padding: 32px;
  }

  .container1-intro h1 {
    font-size: 3rem;
    font-weight: 500;
  }

  .container1-intro button {
    width: 75%;
  }

  .container1-content {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  .container1-content img {
    max-width: 75%;
  }

  .pillarLeft {
    width: 100%;
  }
}

@media screen and (min-width: 992px) {
  .container1 {
    flex-direction: row;
  }

  .container1-intro {
    width: 50%;
    justify-content: center;
    align-items: center;
  }

  .container1-intro button {
    width: 70%;
  }

  .container1-content {
    width: 50%;
    height: 100%;
  }

  .container1-content img {
    max-width: 90%;
    min-width: 50%;
    z-index: 10;
  }

  .pillarLeft {
    width: 20%;
  }
}

.mainContainer {
  background-color: white;
}

.container1 {
  width: 100%;
  height: 100vh;
  display: flex;
}

.container1-intro {
  display: flex;
  flex-direction: column;
  background-color: #e5fbfe;
}

.topline {
  width: 20%;
  height: 3px;
  border-radius: 1px;
  margin-bottom: 12px;
  background-color: #56acb7;
}

.container1-intro p {
  color: slategrey;
  letter-spacing: 1px;
  max-width: 70%;
}

.container1-intro button {
  margin-top: 14px;
  padding: 8px;
  outline: none;
  border: none;
  background-color: #56acb7;
}

.container1-intro button:hover {
  background-color: #255a61;
}

.container1-content {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
}

.container1-content img {
  z-index: 10;
  /* mix-blend-mode: darken; */
}

.pillarLeft {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 0;
  background-color: #e5fbfe;
}`, "",{"version":3,"sources":["webpack://./src/components/home/Home.css"],"names":[],"mappings":"AAAA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,cAAc;IACd,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,yBAAyB;AAC3B","sourcesContent":["@media screen and (max-width: 991px) {\n  .container1 {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .container1-intro {\n    width: 100%;\n    justify-content: center;\n    align-items: flex-start;\n  }\n\n  .container1-intro article {\n    margin-top: 7rem;\n    padding: 32px;\n  }\n\n  .container1-intro h1 {\n    font-size: 3rem;\n    font-weight: 500;\n  }\n\n  .container1-intro button {\n    width: 75%;\n  }\n\n  .container1-content {\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .container1-content img {\n    max-width: 75%;\n  }\n\n  .pillarLeft {\n    width: 100%;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .container1 {\n    flex-direction: row;\n  }\n\n  .container1-intro {\n    width: 50%;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .container1-intro button {\n    width: 70%;\n  }\n\n  .container1-content {\n    width: 50%;\n    height: 100%;\n  }\n\n  .container1-content img {\n    max-width: 90%;\n    min-width: 50%;\n    z-index: 10;\n  }\n\n  .pillarLeft {\n    width: 20%;\n  }\n}\n\n.mainContainer {\n  background-color: white;\n}\n\n.container1 {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n}\n\n.container1-intro {\n  display: flex;\n  flex-direction: column;\n  background-color: #e5fbfe;\n}\n\n.topline {\n  width: 20%;\n  height: 3px;\n  border-radius: 1px;\n  margin-bottom: 12px;\n  background-color: #56acb7;\n}\n\n.container1-intro p {\n  color: slategrey;\n  letter-spacing: 1px;\n  max-width: 70%;\n}\n\n.container1-intro button {\n  margin-top: 14px;\n  padding: 8px;\n  outline: none;\n  border: none;\n  background-color: #56acb7;\n}\n\n.container1-intro button:hover {\n  background-color: #255a61;\n}\n\n.container1-content {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.container1-content img {\n  z-index: 10;\n  /* mix-blend-mode: darken; */\n}\n\n.pillarLeft {\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 0;\n  background-color: #e5fbfe;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
